import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Select,
  Space,
  Tooltip,
  Typography,
  Radio,
  Row,
  ColorPicker,
  InputNumber,
  AutoComplete,
  TimePicker,
  Button,
} from "antd";
import React, {useEffect, useState} from "react";
import {FIELD_TYPE} from "types/enums";
import {FORMAT_TIME} from "types/enums/format-time";
import "components/common/InputFields/FormItem/FormItem.scss";
import InputCode from "components/common/Code/Code";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import {Option} from "antd/es/mentions";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
import {AddBtnSVG} from "assets";

dayjs.locale("vi");
const {
  INPUT,
  INPUT_PASSWORD,
  SELECT,
  DATE,
  CHECKBOX,
  RADIO,
  RADIO_VN,
  RADIO_BUTTON,
  COLOR,
  NUMBER,
  AUTO_COMPLETE,
  CURRENCY,
  CODE,
  COMBO_BOX,
  TEXT_AREA,
  TIME,
  DATE_PRE,
  DATE_ON,
  DATE_DISABLE,
  DATE_DISABLE_NO_DAY,
  NORMAL_CHECKBOX,
  NORMAL_CHECKBOX_NONE,
  DATE_DAY_INPUT,
  TEXTT_AREA_CUSTOM,
  INPUT_NUMBER,
  SELECT_MULTI,
  CURRENCY_NEGATIVE,
  COMBO_BOX_ADD,
} = FIELD_TYPE;

const FormItem = props => {
  const {
    placeholder,
    suffix,
    disable,
    checkbox,
    type,
    options,
    addonAfter,
    radioButtons,
    optionsTime = {showTime: false, format: FORMAT_TIME.dayFull},
    className,
    labelCol,
    wrapperCol,
    rules,
    name,
    label,
    value,
    radioButton,
    onChange,
    onSearch,
    onPressEnter,
    statusDrug,
    defaultValue,
    onSelect,
    radioCustom,
    disableDate = true,
    disabledDate,
    minCurrency = 0,
    valuePropName,
    mode,
    filterOption,
    initialValue = null,
    allowClear = true,
    changeOnBlur,
    loading = false,
    onOpenChange,
    formatter,
    needConfirm = false,
    onClick,
    btn = false,
    ...rest
  } = props;
  const [isOpenDate, setIsOpenDate] = useState<boolean>(false);
  const renderFormItem = () => {
    switch (type) {
      case INPUT:
        return (
          <Input
            style={{
              width: "100%",
            }}
            value={value ?? null}
            placeholder={!disable ? placeholder ?? "Nhập" : "--"}
            suffix={suffix}
            disabled={disable}
            addonAfter={addonAfter}
            allowClear
            onChange={onChange}
            {...rest}
          />
        );
      case COMBO_BOX_ADD:
        return (
          <Select
            mode={mode}
            showSearch
            style={{
              width: "100%",
            }}
            filterOption={(input, option) =>
              (option?.label?.toString().toLowerCase() ?? "").includes(
                input.toLowerCase()
              )
            }
            defaultValue={value ?? null}
            placeholder={!disable ? placeholder ?? "Chọn" : "--"}
            options={options}
            disabled={disable}
            allowClear={allowClear}
            onChange={onChange}
            {...rest}
          />
        );
      case INPUT_NUMBER:
        return (
          <InputNumber
            style={{
              width: "100%",
            }}
            suffix={suffix}
            disabled={disable}
            addonAfter={addonAfter}
            allowClear
            controls={false}
            onChange={onChange}
            type="number"
            {...rest}
          />
        );
      case INPUT_PASSWORD:
        return (
          <Input.Password
            placeholder="Nhập mật khẩu"
            allowClear
            iconRender={visible =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            {...rest}
          />
        );
      case TEXT_AREA:
        return (
          <Input.TextArea
            value={value ?? null}
            placeholder={!disable ? placeholder ?? "Nhập" : "--"}
            allowClear
            onChange={onChange}
            disabled={disable}
            autoSize
            rows={1}
            {...rest}
          />
        );
      case COMBO_BOX:
        return (
          <Select
            mode={mode}
            showSearch
            style={{
              width: "100%",
            }}
            filterOption={(input, option) =>
              (option?.label?.toString().toLowerCase() ?? "").includes(
                input.toLowerCase()
              )
            }
            defaultValue={value ?? null}
            placeholder={!disable ? placeholder ?? "Chọn" : "--"}
            options={options}
            disabled={disable}
            allowClear={allowClear}
            onChange={onChange}
            {...rest}
          />
        );
      case SELECT_MULTI:
        return (
          <Select mode="tags" style={{width: "100%"}}>
            {options.map(e => (
              <Option value={e.value}>{e.label}</Option>
            ))}
          </Select>
        );
      case SELECT:
        return (
          <Select
            style={{
              width: "100%",
            }}
            placeholder={!disable ? placeholder ?? "Chọn" : "--"}
            options={options}
            disabled={disable}
            onChange={onChange}
            allowClear={allowClear}
            mode={mode}
            {...rest}
            filterOption={(input, option) =>
              (option?.label.toString().toLowerCase() ?? "").includes(
                input.toLowerCase()
              )
            }
          />
        );

      case DATE:
        return (
          <DatePicker
            style={{
              width: "100%",
            }}
            disabled={disable}
            format={optionsTime.format}
            showTime={optionsTime.format == FORMAT_TIME.dateTime}
            {...rest}
            disabledDate={
              disableDate
                ? current => {
                    return current.isAfter(dayjs());
                  }
                : false
            }
            placeholder={!disable ? optionsTime.format ?? "Chọn" : "--"}
            onChange={onChange}
            allowClear
            onOpenChange={onOpenChange}
            changeOnBlur={changeOnBlur}
            needConfirm={false}
          />
        );
      case DATE_DAY_INPUT:
        return (
          <DatePicker
            style={{
              width: "100%",
            }}
            disabled={disable}
            format={isOpenDate ? "DDMMYYYY" : optionsTime.format}
            showTime={optionsTime.format == FORMAT_TIME.dateTime}
            {...rest}
            disabledDate={
              disableDate
                ? current => {
                    // let customDate = moment().format(FORMAT_TIME.day);
                    return current && current.valueOf() >= Date.now();
                  }
                : false
            }
            placeholder={!disable ? optionsTime.format ?? "Chọn" : "--"}
            onOpenChange={() => setIsOpenDate(!isOpenDate)}
            onChange={onChange}
          />
        );
      case DATE_DISABLE:
        return (
          <DatePicker
            style={{
              width: "100%",
            }}
            placeholder={optionsTime.format}
            disabled={disable}
            format={optionsTime.format}
            showTime={optionsTime.format == FORMAT_TIME.dateTime}
            {...rest}
            disabledDate={
              disabledDate
                ? current => {
                    return disabledDate(current) || current > dayjs();
                  }
                : current => {
                    return current > dayjs();
                  }
            }
            onChange={onChange}
          />
        );
      case DATE_DISABLE_NO_DAY:
        return (
          <DatePicker
            style={{
              width: "100%",
            }}
            placeholder={!disable ? optionsTime.format ?? "Chọn" : "--"}
            disabled={disable}
            format={isOpenDate ? "DDMMYYYY" : optionsTime.format}
            showTime={optionsTime.format === FORMAT_TIME.dateTime}
            {...rest}
            disabledDate={
              disabledDate ? current => disabledDate(current) : () => false
            }
            onChange={onChange}
            onOpenChange={() => setIsOpenDate(!isOpenDate)}
          />
        );
      case DATE_PRE:
        return (
          <DatePicker
            style={{
              width: "100%",
            }}
            placeholder={optionsTime.format}
            disabled={disable}
            format={optionsTime.format}
            showTime={optionsTime.format == FORMAT_TIME.dateTime}
            {...rest}
            disabledDate={current => {
              return current && current.valueOf() <= Date.now();
            }}
            needConfirm={needConfirm}
            onChange={onChange}
          />
        );
      case DATE_ON:
        return (
          <DatePicker
            style={{
              width: "100%",
            }}
            placeholder={optionsTime.format}
            // disabled={disable}
            format={optionsTime.format}
            showTime={optionsTime.format == FORMAT_TIME.dateTime}
            {...rest}
            disabledDate={current => {
              // So sánh ngày của selectedDay với ngày hiện tại (today)
              return (
                current &&
                (current < dayjs().subtract(1, "day").endOf("day") ||
                  current > dayjs().endOf("day"))
              );
            }}
            onChange={onChange}
            // needConfirm={needConfirm}
          />
        );

      case TIME:
        return (
          <TimePicker
            style={{
              width: "100%",
            }}
            needConfirm={needConfirm}
            placeholder={optionsTime.format}
            disabled={disable}
            format={optionsTime.format}
            showTime={optionsTime.format == FORMAT_TIME.time}
            {...rest}
          />
        );
      case CHECKBOX:
        return (
          <Checkbox.Group disabled={disable} onChange={onChange}>
            <Row>
              {checkbox?.map((item, index) => (
                <Col key={index} span={item.span}>
                  <Checkbox
                    value={item.value}
                    style={{
                      width: "100%",
                    }}
                  >
                    {item.label}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        );
      // normal đéo j
      case NORMAL_CHECKBOX:
        return (
          <Checkbox
            value={value}
            style={{
              width: "100%",
            }}
            defaultChecked={false}
            disabled={disable}
          ></Checkbox>
        );
      case NORMAL_CHECKBOX_NONE:
        return (
          <Checkbox
            value={value}
            style={{
              width: "100%",
            }}
            defaultChecked={false}
            disabled={disable}
            onChange={onChange}
          ></Checkbox>
        );
      case RADIO:
        return (
          <Radio.Group value={true} disabled={disable}>
            {options ? (
              <Row
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                {options.map(e => {
                  return <Radio value={e?.value}>{e?.label}</Radio>;
                })}
              </Row>
            ) : (
              <>
                {" "}
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </>
            )}
          </Radio.Group>
        );
      case RADIO_VN:
        return (
          <Radio.Group value={true} disabled={disable} onChange={onChange}>
            {options ? (
              <Row
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                {options.map(e => {
                  return <Radio value={e?.value}>{e?.label}</Radio>;
                })}
              </Row>
            ) : (
              <>
                {" "}
                <Radio value={true}>Có</Radio>
                <Radio value={false}>Không</Radio>
              </>
            )}
          </Radio.Group>
        );
      case RADIO_BUTTON:
        return (
          <Radio.Group
            style={{width: "100%"}}
            size="middle"
            buttonStyle="solid"
            disabled={disable}
            onChange={onChange}
          >
            <Row justify={"center"}>
              {radioButtons?.map((item, index) => {
                if (item.span) {
                  return (
                    <Col span={item.span} key={index}>
                      <Tooltip title={item.label}>
                        <Radio.Button
                          className="button-radio"
                          value={item.value}
                        >
                          {item.label}
                        </Radio.Button>
                      </Tooltip>
                    </Col>
                  );
                } else
                  return (
                    <Col flex={1} key={index}>
                      <Tooltip title={item.label}>
                        <Radio.Button
                          className="button-radio"
                          value={item.value}
                        >
                          {item.label}
                        </Radio.Button>
                      </Tooltip>
                    </Col>
                  );
              })}
            </Row>
          </Radio.Group>
        );

      case COLOR:
        return (
          <ColorPicker
            value={value}
            defaultValue={value}
            disabled={disable}
            {...rest}
          ></ColorPicker>
        );

      case NUMBER:
        return (
          <InputNumber
            style={{width: "100%"}}
            placeholder={!disable ? placeholder ?? "Nhập" : "--"}
            disabled={disable}
            value={value}
            addonAfter={addonAfter}
            defaultValue={value}
            controls={false}
            onChange={onChange}
            {...rest}
          ></InputNumber>
        );
      case AUTO_COMPLETE:
        return (
          <AutoComplete
            showSearch
            allowClear
            placeholder={!disable ? placeholder ?? "Chọn" : "--"}
            notFoundContent={null}
            value={value}
            onSelect={onSelect}
            defaultActiveFirstOption={false}
            filterOption={
              filterOption
                ? filterOption
                : (inputValue, option) =>
                    option!.label
                      ?.toString()
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
            }
            options={options}
            disabled={disable}
            onChange={onChange}
            onSearch={onSearch}
            {...rest}
          ></AutoComplete>
        );
      case CURRENCY:
        return (
          <InputNumber
            style={{width: "100%"}}
            defaultValue={value}
            formatter={(value: any) =>
              formatter
                ? formatter(value)
                : `${Math.round(value)?.toString()}`.replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )
            }
            parser={value => value!.replace(/\$\s?|(,*)/g, "")}
            onChange={onChange}
            addonAfter="VNĐ"
            stringMode
            controls={false}
            disabled={disable}
            min={minCurrency}
            {...rest}
          />
        );
      case CURRENCY_NEGATIVE:
        return (
          <InputNumber
            style={{width: "100%"}}
            defaultValue={value}
            formatter={(value: any) =>
              formatter
                ? formatter(value)
                : `${Math.round(value)?.toString()}`.replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                  )
            }
            parser={value => value!.replace(/\$\s?|(,*)/g, "")}
            onChange={onChange}
            addonAfter="VNĐ"
            stringMode
            controls={false}
            disabled={disable}
            min={Number.MIN_SAFE_INTEGER - 1}
            {...rest}
          />
        );
      case CODE:
        return (
          <Form.Item name={name}>
            <InputCode
              // {...props}
              value={value}
              placeholder={placeholder ?? "Nhập"}
            ></InputCode>
          </Form.Item>
        );

      case TEXTT_AREA_CUSTOM:
        return <textarea value={value} onChange={onChange} />;

      default:
        break;
    }
  };
  return (
    <Form.Item
      className={className}
      rules={rules}
      labelCol={{
        xs: labelCol.xs,
        sm: labelCol.sm,
        md: labelCol.md,
        lg: labelCol.lg,
        xl: labelCol.xl,
      }}
      wrapperCol={{
        xs: wrapperCol.xs,
        sm: wrapperCol.sm,
        md: wrapperCol.md,
        lg: wrapperCol.lg,
        xl: wrapperCol.xl,
      }}
      initialValue={initialValue}
      key={name}
      label={
        label ? (
          <>
            {btn && (
              <Button
                type="text"
                id="btn-add-group"
                icon={<AddBtnSVG />}
                onClick={() => {
                  onClick();
                }}
              />
            )}

            <Tooltip placement="bottom" arrow={false} title={label}>
              <Typography.Text
                className="form-item-text"
                style={{
                  // whiteSpace: "pre-wrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  marginRight: "5px",
                }}
              >
                {label}
              </Typography.Text>
            </Tooltip>
          </>
        ) : (
          ""
        )
      }
      valuePropName={valuePropName}
      name={name}
    >
      {renderFormItem()}
    </Form.Item>
  );
};

export default FormItem;
